let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("jf7jK")]).then(() => parcelRequire('co8Yt'));